module.exports = __webpack_public_path__ + "img/listArrow-r.23594350.svg";